import { create } from "zustand";

export type ValidateProcurementSupplierFormValues = {
  companyName: string;
  country: string;
  companyId: string;
  vat: string;
};

export type RegisterProcurementSupplierSupplierValues = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
  repeatPassword: string;
  acceptTerms: boolean;
};

type RegisterSupplierState = {
  validatedData: ValidateProcurementSupplierFormValues | null;
  userData: RegisterProcurementSupplierSupplierValues | null;
  setValidatedData: (data: ValidateProcurementSupplierFormValues) => void;
  setUserData: (data: RegisterProcurementSupplierSupplierValues) => void;
  reset: () => void;
};

export const useRegisterSupplierStore = create<RegisterSupplierState>((set) => ({
  validatedData: {
    companyName: "",
    country: "",
    companyId: "",
    vat: "",
  },
  userData: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    repeatPassword: "",
    acceptTerms: false,
  },
  setValidatedData: (data: ValidateProcurementSupplierFormValues): void =>
    set({ validatedData: data }),
  setUserData: (data: RegisterProcurementSupplierSupplierValues): void =>
    set({ userData: data }),
  reset: (): void => set({ validatedData: null, userData: null }),
}));
